/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PilotPilotRarity from './PilotPilotRarity';
import PilotPilotStatType from './PilotPilotStatType';

/**
 * The PilotMetadata model module.
 * @module model/PilotMetadata
 * @version 1.0
 */
class PilotMetadata {
    /**
     * Constructs a new <code>PilotMetadata</code>.
     * @alias module:model/PilotMetadata
     */
    constructor() { 
        
        PilotMetadata.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PilotMetadata</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PilotMetadata} obj Optional instance to populate.
     * @return {module:model/PilotMetadata} The populated <code>PilotMetadata</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PilotMetadata();

            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('nftRarity')) {
                obj['nftRarity'] = PilotPilotRarity.constructFromObject(data['nftRarity']);
            }
            if (data.hasOwnProperty('statType')) {
                obj['statType'] = PilotPilotStatType.constructFromObject(data['statType']);
            }
            if (data.hasOwnProperty('statAmount')) {
                obj['statAmount'] = ApiClient.convertToType(data['statAmount'], 'Number');
            }
            if (data.hasOwnProperty('skillType1')) {
                obj['skillType1'] = ApiClient.convertToType(data['skillType1'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount1')) {
                obj['skillAmount1'] = ApiClient.convertToType(data['skillAmount1'], 'Number');
            }
            if (data.hasOwnProperty('skillType2')) {
                obj['skillType2'] = ApiClient.convertToType(data['skillType2'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount2')) {
                obj['skillAmount2'] = ApiClient.convertToType(data['skillAmount2'], 'Number');
            }
            if (data.hasOwnProperty('skillType3')) {
                obj['skillType3'] = ApiClient.convertToType(data['skillType3'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount3')) {
                obj['skillAmount3'] = ApiClient.convertToType(data['skillAmount3'], 'Number');
            }
            if (data.hasOwnProperty('skillType4')) {
                obj['skillType4'] = ApiClient.convertToType(data['skillType4'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount4')) {
                obj['skillAmount4'] = ApiClient.convertToType(data['skillAmount4'], 'Number');
            }
            if (data.hasOwnProperty('skillType5')) {
                obj['skillType5'] = ApiClient.convertToType(data['skillType5'], 'Number');
            }
            if (data.hasOwnProperty('skillAmount5')) {
                obj['skillAmount5'] = ApiClient.convertToType(data['skillAmount5'], 'Number');
            }
            if (data.hasOwnProperty('property')) {
                obj['property'] = ApiClient.convertToType(data['property'], 'String');
            }
            if (data.hasOwnProperty('metaDataCreatedAt')) {
                obj['metaDataCreatedAt'] = ApiClient.convertToType(data['metaDataCreatedAt'], 'Date');
            }
            if (data.hasOwnProperty('metaDataUpdatedAt')) {
                obj['metaDataUpdatedAt'] = ApiClient.convertToType(data['metaDataUpdatedAt'], 'Date');
            }
            if (data.hasOwnProperty('lastImportedAt')) {
                obj['lastImportedAt'] = ApiClient.convertToType(data['lastImportedAt'], 'Date');
            }
            if (data.hasOwnProperty('slotNumber')) {
                obj['slotNumber'] = ApiClient.convertToType(data['slotNumber'], 'Number');
            }
            if (data.hasOwnProperty('inventoryCreatedAt')) {
                obj['inventoryCreatedAt'] = ApiClient.convertToType(data['inventoryCreatedAt'], 'Date');
            }
            if (data.hasOwnProperty('inventoryUpdatedAt')) {
                obj['inventoryUpdatedAt'] = ApiClient.convertToType(data['inventoryUpdatedAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PilotMetadata</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PilotMetadata</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['property'] && !(typeof data['property'] === 'string' || data['property'] instanceof String)) {
            throw new Error("Expected the field `property` to be a primitive type in the JSON string but got " + data['property']);
        }

        return true;
    }


}



/**
 * @member {Number} nftUid
 */
PilotMetadata.prototype['nftUid'] = undefined;

/**
 * @member {module:model/PilotPilotRarity} nftRarity
 */
PilotMetadata.prototype['nftRarity'] = undefined;

/**
 * @member {module:model/PilotPilotStatType} statType
 */
PilotMetadata.prototype['statType'] = undefined;

/**
 * @member {Number} statAmount
 */
PilotMetadata.prototype['statAmount'] = undefined;

/**
 * @member {Number} skillType1
 */
PilotMetadata.prototype['skillType1'] = undefined;

/**
 * @member {Number} skillAmount1
 */
PilotMetadata.prototype['skillAmount1'] = undefined;

/**
 * @member {Number} skillType2
 */
PilotMetadata.prototype['skillType2'] = undefined;

/**
 * @member {Number} skillAmount2
 */
PilotMetadata.prototype['skillAmount2'] = undefined;

/**
 * @member {Number} skillType3
 */
PilotMetadata.prototype['skillType3'] = undefined;

/**
 * @member {Number} skillAmount3
 */
PilotMetadata.prototype['skillAmount3'] = undefined;

/**
 * @member {Number} skillType4
 */
PilotMetadata.prototype['skillType4'] = undefined;

/**
 * @member {Number} skillAmount4
 */
PilotMetadata.prototype['skillAmount4'] = undefined;

/**
 * @member {Number} skillType5
 */
PilotMetadata.prototype['skillType5'] = undefined;

/**
 * @member {Number} skillAmount5
 */
PilotMetadata.prototype['skillAmount5'] = undefined;

/**
 * @member {String} property
 */
PilotMetadata.prototype['property'] = undefined;

/**
 * @member {Date} metaDataCreatedAt
 */
PilotMetadata.prototype['metaDataCreatedAt'] = undefined;

/**
 * @member {Date} metaDataUpdatedAt
 */
PilotMetadata.prototype['metaDataUpdatedAt'] = undefined;

/**
 * @member {Date} lastImportedAt
 */
PilotMetadata.prototype['lastImportedAt'] = undefined;

/**
 * @member {Number} slotNumber
 */
PilotMetadata.prototype['slotNumber'] = undefined;

/**
 * @member {Date} inventoryCreatedAt
 */
PilotMetadata.prototype['inventoryCreatedAt'] = undefined;

/**
 * @member {Date} inventoryUpdatedAt
 */
PilotMetadata.prototype['inventoryUpdatedAt'] = undefined;






export default PilotMetadata;

